
import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { Notification } from '@/classes/models'

export default class NotificationService {
  /**
   * Get notifications
   *
   * @param {TableRequest} parameters
   *
   * @return {Promise}
   */
  static getAll (parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(this.endpoint(), {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      // Map to Notifications
      response.data = response.data.map(notification => new Notification(notification))

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  /**
   * Get a notification.
   *
   * @param {string} reference
   *
   * @return {Promise}
   */
  static get (reference) {
    let request = portalApi.get(`${this.endpoint()}/${reference}`).then(response => {
      return response.data
    })

    return request.then(response => {
      // Map to Notification
      return new Notification(response.data)
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Create a notification
   *
   * @param {Object} data
   *
   * @return {Promise}
   */
  static add (data) {
    return portalApi.post(this.endpoint(), data).then(response => {
      return response.data
    }).then(response => {
      // Map to Notification
      return new Notification(response.data)
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Update a notification.
   *
   * @param {string} reference
   * @param {Object} data
   *
   * @return {Promise}
   */
  static update (reference, data) {
    return portalApi.put(`${this.endpoint()}/${reference}`, data)
  }

  /**
   * Delete a notification.
   *
   * @param {string} reference
   *
   * @return {Promise}
   */
  static delete (reference) {
    return portalApi.delete(`${this.endpoint()}/${reference}`)
  }

  static getUserNotifications (parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(`/user${this.endpoint()}`, {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams() : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      // Map to Notifications
      response.data = response.data.map(notification => new Notification(notification))

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  static getUserNotification (reference) {
    let request = portalApi.get(`/user${this.endpoint()}/${reference}`).then(response => {
      return response.data
    })

    return request.then(response => {
      const { content, ...notification } = response.data

      // Map to Notification
      return new Notification({ content: JSON.parse(content), ...notification })
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  static getUserNotificationStatus () {
    return portalApi.get(`/user${this.endpoint()}/status`).then(response => {
      return response.data
    })
  }

  /**
     * Endpoint of API.
     *
     * @return {string}
     */
  static endpoint () {
    return '/notifications'
  }
}
